// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__Up3yd","file":"styles_file__CBmB2"};